<template>
    <div>
        <b-modal id="addqueue" ref="addqueue" @show="getMember" @hide="closeModal" hide-header hide-footer
            no-close-on-backdrop no-close-on-esc centered>
            <div class="container-add-rule">
                <div class="d-flex justify-content-end">
                    <feather @click="$refs.addqueue.hide()" style="width: 15px; cursor: pointer" type="x"></feather>
                </div>
                <div class="px-2 py-0">
                    <p style="font-size: 17px; font-weight: 500">
                        {{ editData != null ? 'Edit Queue' : 'Add Queue' }}
                    </p>
                </div>
                <div class="px-2">
                    <div class="mt-2">
                        <p style="margin: 0; font-size: 14px">Queue Name</p>
                        <div style="width: 100%">
                            <b-form-input placeholder="Queue Name" class="inputBox"
                                :class="{ 'border-red': isRequired && queueName == '' }"
                                style="border: 1px solid #cdcdcd; width: 100%; height: 100%" type="text"
                                v-model="queueName" />
                            <p v-if="isRequired && queueName == ''" style="color: #f73164; font-size: 0.6rem"
                                class="m-1">
                                required
                            </p>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap overflow-auto" style="max-height: 220px;">
                        <div v-for="(item, itemId) in selectedUserList" :key="itemId"
                            class="mt-2 mr-1 p-2 d-flex flex-column align-items-center" style="
                border: 1px solid #b4b4b8;
                border-radius: 5px;
                cursor: pointer;
              " @click="removeSelected(item)">
                            <!-- <img style="width: 3em; border-radius: 50%" alt="user profile picture"
                                src="../../assets/images/user/user-dp.png" /> -->
                            <span class="mt-1">{{ transferName(item.name) }} </span>
                        </div>
                    </div>

                    <div class="mt-2">
                        <p style="margin: 0; font-size: 14px">User</p>
                        <div style="width: 100%">
                            <b-form-input @input="searchUser(search)" class="inputBox" placeholder="User"
                                style="border: 1px solid #cdcdcd; width: 100%; height: 100%" type="text"
                                v-model="search" />
                        </div>
                    </div>
                    <div class="mt-2 selectData">
                        <div v-for="(user, id) in userList" :key="id" class="p-2 d-flex justify-content-between">
                            <div>
                                <!-- <img src="../../assets/images/user/user-dp.png" alt="profile picture"
                                    style="width: 40px" /> -->
                                <span class="">
                                    {{ transferName(user.name) }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center">
                                <b-button @click="selectUser(user)" class="border-0 p-0 mr-0" id="addUserList_btn"
                                    style="background-color: #d5e3fd">
                                    <div class="d-flex justify-content-center align-items-center w-100 h-100 px-3 py-1"
                                        :class="user.isAdded ? 'removeUser-btn' : 'addUser-btn'"
                                        style="font-size: 10px; border-radius: 1em; height: 80%">
                                        <feather class="mr-1" style="width: 1.2em; cursor: pointer"
                                            :type="user.isAdded ? 'check-circle' : 'plus-circle'" />
                                        <span style="font-size: 1.2em">
                                            {{ user.isAdded ? 'Remove' : 'Add' }}</span>
                                    </div>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 d-flex justify-content-end">
                    <b-button @click="addNewQueue" class="border-0 p-0 mr-0" id="addqueue_btn"
                        style="background-color: #d5e3fd">
                        <div class="d-flex justify-content-center align-items-center add-btn w-100 h-100 px-4 py-1"
                            style="
                border-radius: 0.3em;
                background: #6ca0fc;
                color: white;
                height: 80%;
              ">
                            <feather class="mr-1" style="width: 0.8em; cursor: pointer" type="save" />
                            <span style="font-size: 0.9em">Save</span>
                        </div>
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { requestService } from '../../_services';
export default {
    // props: ['editData'],
    data() {
        return {
            editData: null,
            isRequired: false,
            queueName: '',
            search: '',
            selectedUserList: [],
            userList: [],
            userListDefault: [],
        };
    },
    methods: {
        removeSelected(item) {
            this.selectedUserList = this.selectedUserList.filter((e) => {
                return e._id != item._id;
            });
            this.userList.forEach((data) => {
                if (data._id == item._id) {
                    data.isAdded = false;
                }
            });
        },
        transferName(name) {
            // console.log('name: ', name)
            if (name.includes(':')) {
                return name.replace(':', ' ');
            } else {
                return name;
            }
        },
        getMember() {
            var url = '/api/mail/ccp_user';
            requestService.GetFetch('ccp', url).then((res) => {
                if (res.status == 200) {
                    res.text().then((text) => {
                        const data = text && JSON.parse(text);
                        let arr = data.data.filter((e) => e.status === 'Enable').map((e) => {
                            let obj = {
                                ...e,
                                isAdded: false,
                            };
                            return obj;
                        });
                        this.userList = arr;
                        this.userListDefault = arr;
                        if (this.editData != null) {
                            this.setData();
                        }
                    });
                }
            });
        },
        selectUser(user) {
            // console.log('user:', user)
            if (user.isAdded) {
                this.selectedUserList = this.selectedUserList.filter((e) => {
                    return e._id != user._id;
                });
            } else {
                this.selectedUserList.push(user);
            }
            user.isAdded = !user.isAdded;
            // this.userListDefault = this.userList
        },
        searchUser(e) {
            if (e == '') {
                this.userList = this.userListDefault;
            } else {
                this.userList = this.userListDefault;
                this.userList = this.userList.filter((row) =>
                    row.name.toLowerCase().includes(e.toLowerCase())
                );
            }
        },
        addNewQueue() {
            let member = this.selectedUserList.map((user) => `${user._id}`);
            let obj = {
                name: this.queueName,
                member: member,
            };

            // console.log(obj);
            if (this.queueName == '') {
                this.isRequired = true
                console.log('blank')
            } else {
                this.isRequired = false
                if (this.editData == null) {
                    this.$emit('addNewQue', obj);
                } else {
                    // console.log('2')
                    obj._id = this.editData._id;
                    obj.status = this.editData.status;
                    this.$emit('editQue', obj);
                }
                this.$refs['addqueue'].hide();
            }
        },
        async setData() {
            this.queueName = this.editData.name;
            const mappedNames = this.editData.member.map((id) => {
                const matchedItem = this.userList.find((item) => item._id === id);
                this.userList.forEach((e) => {
                    if (e._id === id) {
                        e.isAdded = true;
                    }
                });
                return matchedItem
                    ? { _id: matchedItem._id, name: matchedItem.name }
                    : null;
            }).filter((item) => item !== null);
            this.selectedUserList = mappedNames;
        },
        closeModal() {
            this.isRequired = false;
            this.editData = null;
            this.queueName = '';
            this.search = '';
            this.selectedUserList = [];
        },
    },
};
</script>

<style scoped>
.border-red {
    border: 1.5px solid red !important;
}

.selectData {
    overflow: auto;
    height: 20dvh;
}

/* .selectedBox {
    height: 9em;
    font-size: 10px;
    border: 1px solid
} */

.addUser-btn {
    background: #d5eaff;
    color: #057afb;
    transition: background-color 0.2s, color 0.2s;
}

.addUser-btn:hover {
    background: #c6dcf1 !important;
    color: #025bbf !important;
}

.removeUser-btn {
    background: #ffd8db;
    color: #dc3c45;
    transition: background-color 0.2s, color 0.2s;
}

.removeUser-btn:hover {
    background: #e8c0c4 !important;
    color: #ad373f !important;
}

.inputBox {
    font-size: 12px;
    height: 3.4em !important;
}

button#addUserList_btn {
    background-color: transparent !important;
}

button#addqueue_btn {
    background-color: transparent !important;
}
</style>
